import colors from '@lmc/common/constants'
import { Badge } from '@lmc/ui-kit'
import type React from 'react'
import type { TFunction } from 'react-i18next'

export enum BadgeType {
  Overdue = 'Overdue',
  DueSoon = 'DueSoon',
  NotSet = 'NotSet'
}

export const CarerSkillsTableBadges = (
  status: string | undefined,
  t: TFunction<'translation', undefined>
): React.ReactElement => {
  switch (status) {
    case BadgeType.DueSoon: {
      return (
        <Badge
          text={t(`skillsAndNeeds.table.dueSoon`)}
          color={colors.initialcolorbadge}
          textColor={colors.black}
          style={{ width: 'fit-content' }}
        />
      )
    }
    case BadgeType.Overdue: {
      return (
        <Badge
          text={t(`skillsAndNeeds.table.overDue`)}
          color={colors.dnacprcolorbadge}
          textColor={colors.black}
          style={{ width: 'fit-content' }}
        />
      )
    }
    case BadgeType.NotSet: {
      return (
        <Badge
          text={t(`skillsAndNeeds.table.noSet`)}
          color={colors.dnacprcolorbadge}
          textColor={colors.black}
          style={{ width: 'fit-content' }}
        />
      )
    }
    default: {
      return <>-</>
    }
  }
}

interface RenderRowCellProps {
  children?: React.ReactNode
  classVariable: any
}
export function RenderRowCell(props: RenderRowCellProps) {
  const { classVariable, children } = props
  return <span style={classVariable}>{children}</span>
}
